/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconList = createReactComponent("list", "IconList", [
  ["path", { d: "M9 6l11 0", key: "svg-0" }],
  ["path", { d: "M9 12l11 0", key: "svg-1" }],
  ["path", { d: "M9 18l11 0", key: "svg-2" }],
  ["path", { d: "M5 6l0 .01", key: "svg-3" }],
  ["path", { d: "M5 12l0 .01", key: "svg-4" }],
  ["path", { d: "M5 18l0 .01", key: "svg-5" }]
]);

export { IconList as default };
//# sourceMappingURL=IconList.js.map
